import { InfoCard, InfoCardProps } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

export interface IAttributes extends InfoCardProps {
  body: string
  mediaUrl: string
}

const InfoCardBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <InfoCard
      {...attributes}
      body={parse(attributes.body ?? '')}
      icon={<img src={attributes.mediaUrl} alt="" width="100%" height="100%" />}
      linkText={attributes.linkText}
      linkUrl={attributes.linkUrl}
    />
  )
}

export default InfoCardBlock
